module.exports = __webpack_public_path__ + "img/Printing invoices-bro.8bf55bf8.svg";